export const SOCIAL_LINKS = {
  whatsappChannel: "https://whatsapp.com/channel/0029VbCKfuD84OmKKxJRUj2O",
  instagram: "https://www.instagram.com/limpook_mlbb_store?igsh=M211cW1wanNmcTdq",
  youtube: "https://youtube.com/@limpook?si=eQ8XMA-HVxLJMO8o",
  whatsappGroup: "https://chat.whatsapp.com/D8OPkdiiLQr9L6bHaU7ZPQ",
  whatsappSupport: "https://wa.me/918072865201",
  facebook: "",
};
